module.exports = "<div seedelement>\n  <div class=\"lui-navigationdrawer__header\">\n    <div class=\"lui-navigationdrawer__productlogo\">\n      <slot name=\"productlogo\">\n        <lui-logo></lui-logo>\n      </slot>\n    </div>\n    <slot name=\"controls\"></slot>\n  </div>\n  <div class=\"lui-navigationdrawer__main\">\n    <slot></slot>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/theme/lui-navigationdrawer.html
// module id = 259
// module chunks = 0 1 9